import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Demo() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <div className="w-full bg-blue-900 text-white py-4 fixed top-0 left-0 z-50 ">
        <nav className="max-w-7xl mx-auto px-4 flex justify-between items-center  bg-blue-900">
          {/* Logo Section */}
          <div className="flex items-center">
          <span className="text-4xl font-extrabold text-slate-100 group-hover:text-white tracking-wide  decoration-indigo-500 decoration-2">
  PREVOMICS
</span>
          </div>

          {/* Menu Toggle for Small Screens */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          </div>

          {/* Navigation Links */}
          <div
            className={`${
              isMenuOpen ? 'block' : 'hidden'
            } absolute top-16 left-0 w-full bg-blue-900 md:static md:flex md:items-center md:justify-end md:space-x-8`}
          >
            <Link
              to="/"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              Home
            </Link>
            <Link
              to="/home"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              Contact Us
            </Link>
            <Link
              to="/about"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              About Us
            </Link>

          
            <Link
              to="/services"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              Package

            </Link>

            <Link
              to="/register"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              Register
            </Link>
            <Link
              to="/login"
              className="block md:inline-block text-white font-medium hover:text-purple-300 transition-all duration-300 px-4 py-2"
            >
              Log In
            </Link>
          
          </div>
        </nav>
      </div>
    </>
  );
}

export default Demo;
